<template>
  <router-link
    class="webphone-aside__nav__link"
    :to="link.path"
  >
    {{ link.name }}
  </router-link>
</template>

<script>
  export default {
    name: 'WebphoneNavLink',
    props: ['link'],
  };
</script>

<style lang="scss" scoped>
  .webphone-aside {
    &__nav {
      &__link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: calc(100% / 3);
        color: var(--gray500);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
        text-transform: capitalize;
        padding: 10px;
        border-bottom: 2px solid var(--gray100);
        transition:
          color 300ms ease-in-out,
          font-weight 300ms ease-in-out,
          border-bottom-color 300ms ease-in-out;

        &:hover {
          color: var(--color-base-500);
          font-weight: 500;
          border-bottom-color: var(--color-base-500);
        }
      }

      .router-link-active {
        color: var(--color-base-500);
        font-weight: 500;
        border-bottom-color: var(--color-base-500);
      }
    }
  }

  :root[data-theme='dark'] {
    .webphone-aside__nav__link {
      color: var(--shadesBlack);
    }
  }
</style>
